export default __webpack_public_path__ + "static/media/login_banner-movil.271bc0d6.png";